import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { setMessage } from './message';

import firstWeightEntryService from '../services/first-weight-entry.service';


export const fetchFirstWeightEntryList = createAsyncThunk(
    'firstWeightEntry/fetchFirstWeightEntryList',
    async ({ page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await firstWeightEntryService.getFirstWeightEntryList(page, pagesize, search, ordering);
            return response.data;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    },
);

export const fetchArchivedFirstWeightEntrylist = createAsyncThunk(
    'firstWeightEntry/fetchArchiveFirstWeightEntryList',
    async ({ page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await firstWeightEntryService.getArchiveFirstWeightEntryList(page, pagesize, search, ordering);
            return response.data;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    },
);
export const fetchFirstWeightEntryDetails = createAsyncThunk(
    'firstWeightEntry/fetchFirstWeightEntryDetails',
    async (id, { rejectWithValue }) => {
        try {
            const response = await firstWeightEntryService.getFirstWeightEntryDetails(id);
            return response.data; 
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);
export const fetchFirstWeightEntryById = createAsyncThunk(
    'firstWeightEntry/fetchFirstWeightEntryById',
    async (firstWeightEntryId, { rejectWithValue }) => {
        try {
            const response = await firstWeightEntryService.getFirstWeightEntryById(firstWeightEntryId);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);


export const createFirstWeightEntry = createAsyncThunk(
    'firstWeightEntry/createFirstWeightEntry',
    async ({ values }, thunkAPI) => {
        try {
            const textPayload = {
                weight_for: values.weight_for,
                weight_automatic: values.weight_automatic,
                gross_weight: values.gross_weight,
                tare_weight: values.tare_weight,
                date_time_first: values.date_time_first || false,
                date_time_second: values.date_time_second,
                mound: values.mound,
                serial_no: values.serial_no,
                total_copy: values.total_copy,
                vehicle_no: values.vehicle_no,
                vehicle_type: values.vehicle_type?.value,
                party_name: values.party_name?.value,
                purchaser: values.purchaser?.value,
                seller: values.seller?.value,
                party_mobile_no: values.party_mobile_no,
                material: values.material?.value,
                cash_party_name: values.cash_party_name,
                net_weight: values.net_weight,
                weight: values.weight,
              };
         
            
 
              
            const response = await firstWeightEntryService.addFirstWeightEntry(textPayload);
            return response.data; // Assuming response contains the created firstWeightEntry data
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const updateFirstWeightEntry = createAsyncThunk(
    'firstWeightEntry/updateFirstWeightEntry',
    async ({ id, values }, thunkAPI) => {
        try {
            const formPayload = {
                weight_for: values.weight_for,
                weight_automatic: values.weight_automatic,
                gross_weight: values.gross_weight,
                tare_weight: values.tare_weight,
                date_time_first: values.date_time_first || false,
                date_time_second: values.date_time_second,
                mound: values.mound,
                serial_no: values.serial_no,
                total_copy: values.total_copy,
                vehicle_no: values.vehicle_no,
                vehicle_type: values.vehicle_type,
                party_name: values.party_name,
                purchaser: values.purchaser,
                seller: values.seller,
                party_mobile_no: values.party_mobile_no,
                material: values.material,
                // cash_party_name: values.cash_party_name,
                // net_weight: values.net_weight,
                // weight: values.weight,
            };

            const response = await firstWeightEntryService.updateFirstWeightEntry(id, formPayload);

            return response.data; // Return the updated firstWeightEntry data
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const deleteFirstWeightEntry = createAsyncThunk(
    'firstWeightEntry/deleteFirstWeightEntry',
    async (id, thunkAPI) => {
        try {
            await firstWeightEntryService.deleteFirstWeightEntry(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const unArchiveFirstWeightEntry = createAsyncThunk(
    'firstWeightEntry/unArchiveFirstWeightEntry',
    async (id, thunkAPI) => {
        try {
            await firstWeightEntryService.unArchiveFirstWeightEntryRecord(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

const initialState = {
    data: [], // List
    list: [],
    toolsList: [],
    loading: false,
    totalPages: 0,
    currentPage: 1,
    totalRecord: 0,
    status: 'idle',
    error: null,
    hasMore: true,
};


const firstWeightEntrySlice = createSlice({
    name: 'firstWeightEntry',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        resetFirstWeightEntryData: (state) => {
            state.data = []; // This will clear the list
        },
        resetFirstWeightEntryList: (state) => {
            state.list = []; // This will clear the list
        },
        // resetToolsList: (state) => {
        //     state.toolsList = []; // This will clear the list
        // },
        resetCurrentFirstWeightEntryPage: (state) => {
            state.currentPage = 1;
        }
    },
    extraReducers: builder => {
        builder
            .addCase(fetchFirstWeightEntryList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchFirstWeightEntryList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload.results.data || [];
                state.totalPages = action.payload.totalPages;
                state.totalRecord = action.payload.count;
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchFirstWeightEntryList.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });
        builder
            .addCase(fetchArchivedFirstWeightEntrylist.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchArchivedFirstWeightEntrylist.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload.results.data || [];  // Update to match your API response
                state.totalRecord = action.payload.count || 0; // Handle count (total records)
                state.totalPages = action.payload.totalPages || 0; // Handle totalPages
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchArchivedFirstWeightEntrylist.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
            });

        builder
            .addCase(fetchFirstWeightEntryDetails.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchFirstWeightEntryDetails.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(fetchFirstWeightEntryDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });

        builder
            .addCase(fetchFirstWeightEntryById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchFirstWeightEntryById.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(fetchFirstWeightEntryById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });


        builder
            .addCase(createFirstWeightEntry.pending, state => {
                state.status = 'loading';
            })
            .addCase(createFirstWeightEntry.fulfilled, (state, action) => {
                state.status = 'succeeded';
            })
            .addCase(createFirstWeightEntry.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
        builder
            .addCase(updateFirstWeightEntry.pending, state => {
                state.status = 'loading';
            })
            .addCase(updateFirstWeightEntry.fulfilled, (state, action) => {
                state.status = 'succeeded';
            })
            .addCase(updateFirstWeightEntry.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
        builder
            .addCase(deleteFirstWeightEntry.pending, state => {
                state.status = 'loading';
            })
            .addCase(deleteFirstWeightEntry.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
                state.list = state.list.filter(group => group.id !== action.payload); // Remove the deleted group from list
            })
            .addCase(deleteFirstWeightEntry.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.payload;
            });
        builder
            .addCase(unArchiveFirstWeightEntry.pending, state => {
                state.status = 'loading';
            })
            .addCase(unArchiveFirstWeightEntry.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
            })
            .addCase(unArchiveFirstWeightEntry.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export const { resetFirstWeightEntryList, resetFirstWeightEntryData,  resetCurrentFirstWeightEntryPage } = firstWeightEntrySlice.actions;
const { reducer } = firstWeightEntrySlice;
export default reducer;
